import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextButton from '@spothero/ui/text-button';

export default class RedundantMonthlyReservationModal extends PureComponent {
    static propTypes = {
        reservationCreationDateFormatted: PropTypes.string.isRequired,
        parkingPassURL: PropTypes.string.isRequired,
        contactNumber: PropTypes.string.isRequired,
        contactNumberFriendly: PropTypes.string.isRequired,
        onHidden: PropTypes.func.isRequired,
        onCompleteReservation: PropTypes.func.isRequired
    };

    _onNevermindClick = evt => {
        this._modal.hide();
    }

    render() {
        const {
            reservationCreationDateFormatted,
            parkingPassURL,
            contactNumber,
            contactNumberFriendly,
            onCompleteReservation,
            onHidden
        } = this.props;

        /* eslint-disable react/jsx-max-props-per-line */
        return (
            <Modal
                ref={node => { this._modal = node; }}
                className="RedundantMonthlyReservationModal"
                title="Word to the Wise"
                onHidden={onHidden}
            >
                <ModalContent>
                    <p>You have already purchased a reservation for this spot on <strong>{reservationCreationDateFormatted}</strong>.</p>
                    <p>After your first month, you will pay the reservation fee directly to the parking facility. Please follow the instructions in your <a target="_blank" rel="noopener noreferrer" href={parkingPassURL}>Parking Pass</a>. If you complete this reservation you may be charged by both SpotHero and the parking facility.</p>
                    <p>If you would like to purchase multiple spots at this location, please continue below.</p>
                    <p>Have questions? We love to help! Give us a call at <a href={`tel:${contactNumber}`}>{contactNumberFriendly}</a>.</p>
                    <div className="FormActions">
                        <Button
                            color="primary"
                            onClick={onCompleteReservation}
                        >
                            Complete Reservation
                        </Button>
                        <TextButton onClick={this._onNevermindClick}>Nevermind</TextButton>
                    </div>
                </ModalContent>
            </Modal>
        );
        /* eslint-enable react/jsx-max-props-per-line */
    }
}
